import axios from 'axios';

const baseUrl = 'https://nominatim.openstreetmap.org';

export const getAddress = (params = {}) => {
  return axios.get(`${baseUrl}/reverse`, params);
};

export const search = (params = {}) => {
  return axios.get(`${baseUrl}/search`, params);
};
